import { ref } from 'vue';
import { Toast } from '@nutui/nutui';
import { resetApi, loginApi } from '@/apis';

function useSendMsg() {
	const hasSendMsg = ref(false);
	const sendTime = ref(60);
	const handleSendMsg = async (params = {}, type = 'other') => {
		hasSendMsg.value = true;
		const interval = setInterval(() => {
			sendTime.value--;
			if (sendTime.value <= 0) {
				sendTime.value = 60;
				hasSendMsg.value = false;
				clearInterval(interval);
			}
		}, 1000);
		const fn =
			type === 'reset'
				? resetApi.reset_send_code
				: loginApi.send_sms_code;
		try {
			await fn(params);
			Toast.success('短信验证码已发送至您的手机，请查收');
		} catch (error) {
			sendTime.value = 60;
			hasSendMsg.value = false;
			clearInterval(interval);
		}
	};
	return {
		hasSendMsg,
		sendTime,
		handleSendMsg,
	};
}

export default useSendMsg;
